import { CommunicationService } from './../../common/communication.service';
import { AwsUtil } from './../../authentication/aws.service';
import { SearchBarTerm } from './../../common/search-bar/search-bar-term';
import { SnapshotService } from './../../snapshot/snapshot.service';
import { AppConfig } from './../../app.config';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { SearchBarTermOption } from '../../common/search-bar/search-bar-term-option';
import { CurrencyUtil } from '@liquitics/transaction';
import { stringToNumber, numberToString, isValidNumberRange } from '@liquitics/transaction';
import { isTrueString } from '@liquitics/transaction';

import {
    GetTransactionDetailsResult,
    GetTransactionDetailsRequest,
    WebApiEndpoints,
} from '@liquitics/transaction';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SearchBarComponent } from '../../common/search-bar/search-bar.component';
import * as moment from 'moment';

@Component({
    selector: 'app-transaction-search',
    templateUrl: './transaction-search.component.html',
    styleUrls: ['./transaction-search.component.css']
})
export class TransactionSearchComponent implements OnInit {
    searchBarTermOptions: SearchBarTermOption[];
    transactionDetailResult: GetTransactionDetailsResult;

    @ViewChild(SearchBarComponent, { static: true }) searchBarComponent: SearchBarComponent;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        private appConfig: AppConfig,
        private snapshotService: SnapshotService,
        private communicationService: CommunicationService,
        private awsUtil: AwsUtil) {
        this.initOptions();
    }

    ngOnInit() {

    }

    search() {
        this.searchBarComponent.searching = true;
        const errorMessage = this.searchBarComponent.validateSearchBarTerms();
        if (errorMessage) {
            this.communicationService.openSnackBar(errorMessage, 'OK', 3000);
            return;
        }
        const searchBarTerms = this.searchBarComponent.getSearchBarTerms();
        const request = new GetTransactionDetailsRequest();
        const historicalStrings = [];
        searchBarTerms
            .filter((sbt: SearchBarTerm) => {
                return sbt.active && !sbt.invalid;
            })
            .forEach((sbt: SearchBarTerm) => {
                request[sbt.option.searchProperty] = this.toRequestValue(sbt);
                historicalStrings.push(`${sbt.option.name}:${sbt.value}`);
            })
            ;
        request.includeExpected = isTrueString(request.includeActual) ? 'false' : 'true';
        this.awsUtil.webAPICall(WebApiEndpoints.QueryTransactionDetails, request)
            .then((result: GetTransactionDetailsResult) => {
                this.transactionDetailResult = result;
                this.searchBarComponent.searching = false;
            })
            .catch((err) => {
                this.searchBarComponent.searching = false;
            });
        // Disable for now
        // this.searchBarComponent.onSearch(historicalStrings.join(';'), searchBarTerms);
    }

    toRequestValue(searchBarTerm: SearchBarTerm): string | number | boolean {
        const dataType = searchBarTerm.option.dataType;
        if (dataType === 'date') {
            return moment(searchBarTerm.value).format('YYYY-MM-DD');
        } else if (dataType === 'amount') {
            return stringToNumber(searchBarTerm.value);
        } else if (dataType === 'boolean') {
            return searchBarTerm.value; // Keep it a string as it gets sent as a string query parameter anyways
        } else {
            return searchBarTerm.value;
        }
    }

    initOptions() {
        this.searchBarTermOptions = [
            {
                name: 'Currency',
                searchProperty: 'currency',
                dataType: 'string',
                required: true,
                validValues: () => {
                    return CurrencyUtil.CURRENCIES.sort();
                },
                validateValue: (value: string) => {
                    if (!CurrencyUtil.CURRENCIES.includes(value.toUpperCase())) {
                        return 'Invalid currency';
                    }
                },
            } as SearchBarTermOption,
            {
                name: 'SettleDate',
                searchProperty: 'settleDate',
                dataType: 'date',
                required: true,
                validValues: () => {
                    return [this.appConfig.getTodayString()];
                },
                validateValue: (value: string) => {

                },
            } as SearchBarTermOption,
            // {
            //     name: 'TradeDate',
            //     dataType: 'date',
            //     validValues: () => {
            //         return [this.appConfig.getTodayString()];
            //     },
            //     validateValue: (value: string) => {

            //     },
            // } as SearchBarTermOption,
            {
                name: 'MinAmount',
                searchProperty: 'minAmount',
                dataType: 'amount',
                validValues: () => {
                    return [];
                },
                validateValue: (value: string) => {

                },
            } as SearchBarTermOption,
            {
                name: 'MaxAmount',
                searchProperty: 'maxAmount',
                dataType: 'amount',
                validValues: () => {
                    return [];
                },
                validateValue: (value: string) => {

                },
            } as SearchBarTermOption,
            {
                name: 'Desk',
                searchProperty: 'desk',
                dataType: 'string',
                validValues: () => {
                    return this.snapshotService.applicationConfiguration.desks.sort();
                },
                validateValue: (value: string) => {
                    if (!this.snapshotService.applicationConfiguration.desks.includes(value)) {
                        return 'Invalid desk';
                    }
                },
            } as SearchBarTermOption,
            {
                name: 'ProductType',
                searchProperty: 'productType',
                dataType: 'string',
                validValues: () => {
                    return this.snapshotService.applicationConfiguration.productTypes.sort();
                },
                validateValue: (value: string) => {
                    if (!this.snapshotService.applicationConfiguration.productTypes.includes(value)) {
                        return 'Invalid product type';
                    }
                },
            } as SearchBarTermOption,
            {
                name: 'Product',
                searchProperty: 'product',
                dataType: 'string',
                validValues: () => {
                    return this.snapshotService.applicationConfiguration.products.sort();
                },
                validateValue: (value: string) => {
                    if (!this.snapshotService.applicationConfiguration.products.includes(value)) {
                        return 'Invalid product';
                    }
                },
            } as SearchBarTermOption,
            {
                name: 'ClientGroup',
                searchProperty: 'clientGroup',
                dataType: 'string',
                validValues: () => {
                    return this.snapshotService.applicationConfiguration.clientGroups.sort();
                },
                validateValue: (value: string) => {
                    if (!this.snapshotService.applicationConfiguration.clientGroups.includes(value)) {
                        return 'Invalid client group';
                    }
                },
            } as SearchBarTermOption,
            {
                name: 'Client',
                searchProperty: 'client',
                dataType: 'string',
                validValues: () => {
                    return this.snapshotService.applicationConfiguration.clients.sort();
                },
                validateValue: (value: string) => {
                    if (!this.snapshotService.applicationConfiguration.clients.includes(value)) {
                        return 'Invalid client';
                    }
                },
            } as SearchBarTermOption,
            {
                name: 'HoursAgo',
                searchProperty: 'hoursAgoRange',
                dataType: 'timerange',
                validValues: () => {
                    return [];
                },
                validateValue: (value: string) => {
                },
            } as SearchBarTermOption,
            {
                name: 'ExternalId',
                searchProperty: 'externalId',
                dataType: 'string',
                validValues: () => {
                    return [];
                },
                validateValue: (value: string) => {
                },
            } as SearchBarTermOption,
            {
                name: 'Actual',
                searchProperty: 'includeActual',
                dataType: 'boolean',
                validValues: () => {
                    return [];
                },
                validateValue: (value: string) => {
                },
            } as SearchBarTermOption,
        ];
    }

}
